module.exports = __webpack_public_path__ + "images/055edda3e1da1148f3364c85057d3043.activePayments.svg";